import React, { useState } from 'react';
import { Box, Text, Button } from '@chakra-ui/react';

const Story = () => {
  const [storyPart, setStoryPart] = useState(0);

  const storyContent = [
    {
      text: 'You stand before the ancient, forgotten temple, its foreboding doors creaking in the wind.',
      choices: [
        { text: 'Enter the temple', action: () => setStoryPart(1) },
        { text: 'Flee in terror', action: () => setStoryPart(2) },
      ],
    },
    {
      text: 'The temple interior is dark and silent, the air heavy with the scent of bygone eras.',
      choices: [
        { text: 'Light a torch', action: () => setStoryPart(3) },
        { text: 'Proceed in darkness', action: () => setStoryPart(4) },
      ],
    },
    {
      text: 'As you light the torch, the walls come alive with eldritch symbols glowing ominously.',
      choices: [
        { text: 'Examine the symbols', action: () => setStoryPart(5) },
        { text: 'Continue deeper into the temple', action: () => setStoryPart(6) },
      ],
    },
    {
      text: 'The darkness is oppressive, and you feel unseen eyes watching you from the shadows.',
      choices: [
        { text: 'Call out into the darkness', action: () => setStoryPart(7) },
        { text: 'Silently press on', action: () => setStoryPart(8) },
      ],
    },
    {
      text: 'The symbols tell the story of an ancient cosmic war and hint at the power locked within the temple.',
      choices: [
        { text: 'Search for a secret passage', action: () => setStoryPart(9) },
        { text: 'Take notes of the symbols for later', action: () => setStoryPart(10) },
      ],
    },
    {
      text: 'A hidden door slides open, revealing a path leading down into the depths of the earth.',
      choices: [
        { text: 'Descend into the darkness', action: () => setStoryPart(11) },
        { text: 'Seal the passage and leave', action: () => setStoryPart(12) },
      ],
    },
    {
      text: 'You have descended into the depths of the earth and discovered the resting place of an ancient deity. As you approach, the air grows colder and you sense a presence awakening from its slumber.',
      choices: [
        { text: 'Approach the deity', action: () => setStoryPart(13) },
        { text: 'Retreat from the depths', action: () => setStoryPart(14) },
      ],
    },
    {
      text: 'Your presence has awakened the deity. It speaks in a language that twists your mind, offering knowledge and power in exchange for your service.',
      choices: [
        { text: 'Accept the offer', action: () => setStoryPart(15) },
        { text: 'Refuse and attempt to escape', action: () => setStoryPart(16) },
      ],
    },
    {
      text: 'You have accepted the deity\'s offer. Your mind is filled with forbidden knowledge, and you feel a dark power coursing through you. You have become an acolyte of the ancient ones, destined to wander the earth and spread their eldritch influence.',
      choices: [],
    },
    {
      text: 'You have refused the deity and managed to escape the temple. As you emerge into the light, you realize that the world you knew has changed. You are now burdened with the knowledge of the ancient ones, and you must live with the fear of their return.',
      choices: [],
    },
  ];

  return (
    <Box>
      <Text fontSize="2xl" mb={4}>Interactive Storytelling</Text>
      <Text>{storyContent[storyPart].text}</Text>
      <Box mt={4}>
        {storyContent[storyPart].choices.map((choice, index) => (
          <Button key={index} onClick={choice.action} mt={2}>
            {choice.text}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default Story;
